import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorNameDoesNotMatchWithTaxSystem extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Name Does Not Match With The Tax System', options);
    }
}
export default InvestorNameDoesNotMatchWithTaxSystem;
